export default function () {
  this.route("discourse-ai-bot-conversations", {
    path: "/discourse-ai/ai-bot/conversations",
  });
}
